import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import LoadingOverlay from 'react-loading-overlay-ts';
// import { Offline, Online } from "react-detect-offline";
import { useAppStore } from '../stores';
import "./appLayout.css"
import OfflinePage from "./OfflinePage";
import InstallPWA from "./InstallPWA";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";
import HelpVideo from "./HelpVideo";
// import ReactGA from 'react-ga';
const TRACKING_ID = "G-7W7562T94F"; // OUR_TRACKING_ID
// ReactGA.initialize(TRACKING_ID);
const AppLayout = (props) => {
  const loading = useAppStore(state => state.loading);
  const text = useAppStore(state => state.text);
  // useEffect(() => {
  //   ReactGA.pageview(window.location.pathname + window.location.search);
  // }, []);
  return (
    <>
      <Helmet>
        <title>AirBook | Helps students to surpass in academics ever before</title>
        <meta name="description" content="AirBook | Helps students to surpass in academics ever before" />
        <meta name="keywords" content="LMS,students,colleges,AirBook,portal for students" />
        <meta name="author" content="AirBook | AirBook.tech" />
        <meta name="rating" CONTENT="General" />
        <meta name="revisit-after" CONTENT="2 days" />
        <meta name="robots" content="ALL, index, follow" />
        <meta name="distribution" content="Global" />
        <meta name="rating" content="Safe For All" />
        <meta name="language" content="English" />
        <meta http-equiv="window-target" content="_top" />
        <meta http-equiv="pics-label" content="for all ages" />
        <meta name="geo.placename" content="Hyderabad, Telangana, India" />
        <meta name="geo.position" content="17.45704, 78.6664" />
        <meta name="geo.region" content="IN-Telangana" />
        <meta name="ICBM" content="17.45704, 78.6664" />
        <meta name="rating" content="general" />
        <meta content="All, FOLLOW" name="GOOGLEBOTS" />
        <meta content="All, FOLLOW" name="YAHOOBOTS" />
        <meta content="All, FOLLOW" name="MSNBOTS" />
        <meta content="All, FOLLOW" name="BINGBOTS" />
        <meta content="all" name="Googlebot-Image" />
        <meta content="all" name="Slurp" />
        <meta content="all" name="Scooter" />
        <meta content="ALL" name="WEBCRAWLERS" />
        {/* Opengraph Markup Start */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={process.env.PUBLIC_URL} />
        <meta property="og:title" content="AirBook aims to deliver education for every student remotely" />
        <meta property="og:image" content={process.env.PUBLIC_URL + "/favicon.ico"} />
        <meta property="og:site_name" content="AirBook aims to deliver education for every student remotely" />
        <meta property="og:description" content="Platform build for the college students to help students surpass in academics ever before" />
        {/* Opengraph Markup End */}
      </Helmet>
      <InstallPWA />
      <ToastContainer />
      <LoadingOverlay spinner active={loading} text={text}>
        {/* <Online> */}
        <Outlet />
        {/* </Online> */}
        {/* <Offline> */}
        {/* <OfflinePage /> */}
        {/* <Outlet /> */}
        {/* </Offline> */}
      </LoadingOverlay>
    </>
  );
};

export default AppLayout;
